export function initPort(app) {
  app.ports.imageTransform &&
  app.ports.imageTransform.subscribe(function(data) {
    draw(app, data);
  });
}


function draw(app, data) {
  const results = [];
  const dimensions = data.dimensions.length;

  for (let i = 0; i < dimensions; i++) {
    const canvas = document.createElement("canvas");
    const dimension = data.dimensions[i];

    const img = new Image();
    img.src = data.base64;

    img.onload = function() {
      getOrientation(img, orientation => {
        const ctx = canvas.getContext("2d");

        const [width, height] = resizeImage(img, dimension);

        if (4 < orientation && orientation < 9) {
          canvas.width = height;
          canvas.height = width;
        } else {
          canvas.width = width;
          canvas.height = height;
        }

        // transform context before drawing image
        switch (orientation) {
          case 2:
            ctx.transform(-1, 0, 0, 1, width, 0);
            break;
          case 3:
            ctx.transform(-1, 0, 0, -1, width, height);
            break;
          case 4:
            ctx.transform(1, 0, 0, -1, 0, height);
            break;
          case 5:
            ctx.transform(0, 1, 1, 0, 0, 0);
            break;
          case 6:
            ctx.transform(0, 1, -1, 0, height, 0);
            break;
          case 7:
            ctx.transform(0, -1, -1, 0, height, width);
            break;
          case 8:
            ctx.transform(0, -1, 1, 0, 0, width);
            break;
          default:
            break;
        }

        ctx.drawImage(img, 0, 0, width, height);

        canvas.toBlob(blob => {
          results[i] = makeFile([blob], data.name, { type: blob.type, lastModified: data.modified });

          canvas.height = 0;
          canvas.width = 0;
          canvas.remove();

          if (results.length == dimensions && !results.includes(undefined)) {
            app.ports.imageTransformed && app.ports.imageTransformed.send({
              id: data.id,
              files: results,
              kind: data.kind
            });
          }
        }, data.ftype, 0.6);
      });
    };
  }
}

function makeFile(bytes, name, prop) {
  return new File(bytes, name, prop);
}

function resizeImage(img, dimension) {
  let max;
  if (dimension.x > 1 || dimension.y > 1) {
    max = dimension.x > dimension.y ? dimension.x : dimension.y;
  } else {
    max = (img.width > img.height ? img.width : img.height) * 0.666;
  }

  if (img.width > img.height) {
    return [max, max * img.height / img.width];
  } else {
    return [max * img.width / img.height, max];
  }
}

// Credit: https://stackoverflow.com/questions/7584794/accessing-jpeg-exif-rotation-data-in-javascript-on-the-client-side
function getOrientation(img, callback) {
  fetch(img.src)
    .then(r => r.blob())
    .then(blob => {
      const reader = new FileReader();
            reader.readAsArrayBuffer(blob);

      reader.onload = function(e) {
        const view = new DataView(e.target.result);

        if (view.getUint16(0, false) != 0xFFD8) {
          return callback(-2);
        }

        let length = view.byteLength, offset = 2;

        while (offset < length) {
          if (view.getUint16(offset + 2, false) <= 8) return callback(-1);

          const marker = view.getUint16(offset, false);
          offset += 2;

          if (marker == 0xFFE1) {
            if (view.getUint32(offset += 2, false) != 0x45786966) {
              return callback(-1);
            }

            const little = view.getUint16(offset += 6, false) == 0x4949;
            offset += view.getUint32(offset + 4, little);

            const tags = view.getUint16(offset, little);
            offset += 2;

            for (var i = 0; i < tags; i++) {
              if (view.getUint16(offset + (i * 12), little) == 0x0112) {
                return callback(view.getUint16(offset + (i * 12) + 8, little));
              }
            }
          } else if ((marker & 0xFF00) != 0xFF00) {
            break;
          } else {
            offset += view.getUint16(offset, false);
          }
        }

        return callback(-1);
      };
    });
}
